import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { HexPillModule } from "@hex/angular/pill";
import { CommonUtilsModule } from "../common-utils/common-utils.module";

import { CommonToggleFilterActionsDirective } from "./actions.directive";
import { CommonToggleFilterComponent } from "./common-toggle-filter.component";
import { toggleFilterStatePropProvider } from "./state-props";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CommonUtilsModule,
        HexPillModule,
    ],
    exports: [
        CommonToggleFilterComponent,
        CommonToggleFilterActionsDirective,
    ],
    declarations: [
        CommonToggleFilterComponent,
        CommonToggleFilterActionsDirective,
    ],
    providers: [
        CommonToggleFilterActionsDirective,
        toggleFilterStatePropProvider,
    ],
})
export class CommonToggleFilterModule {
}
